import React, { useState } from 'react';
import "./EmailFinderStyle.css"
import { Copy } from "lucide-react";

import SVGComponent from '../../../Utilities/LoaderSvg';




export default function EmailFinderForm() {
  const [state, setState] = useState({
    firstName: "",
    lastName: "",
    companyWebsite: "",
    linkedinUrl: "",
    profileCode: null,
    email: null,
    loading: false,
    errorType: "",
    darkMode: false,
    tooltip: { show: false, text: "" },
    activeTab: "emailFinder",
    profileData: null,
  });

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
    setState((prev) => ({ ...prev, tooltip: { show: true, text: "Copied!" } }));
    setTimeout(() => setState((prev) => ({ ...prev, tooltip: { show: false, text: "" } })), 2000);
  };

  const handleError = (type) => {
    setState((prev) => ({ ...prev, errorType: type, loading: false }));
  };

  const fetchProfileCode = async () => {
    setState((prev) => ({ ...prev, errorType: "", profileCode: null, email: null, loading: true }));

    if (!state.linkedinUrl.startsWith("https://www.linkedin.com/in/")) {
      handleError("invalidLinkedInUrl");
      return;
    }

    try {
      const response = await fetch("https://api.leadbud.io/demo-tools/linkedinChecker", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ linkedin_urls: [state.linkedinUrl] }),
      });

      const data = await response.json();
      if (!response.ok || !data.profile_code) throw new Error(data.message || "Profile not found.");

      setState((prev) => ({ ...prev, profileCode: data.profile_code, loading: false }));
      fetchEmailFromProfile(data.profile_code);
    } catch (err) {
      handleError("temporaryFailure");
    }
  };

  const calculateTenure = (positionGroups) => {
    if (!positionGroups || positionGroups.length === 0) return "No data available";

    const firstPosition = positionGroups[0]; // Get the latest job
    const start = firstPosition.date?.start || {};
    const end = firstPosition.date?.end || {};

    const startYear = start.year || null;
    const startMonth = start.month || 1; // Default to January if month is missing
    const endYear = end.year || new Date().getFullYear(); // Use current year if still working
    const endMonth = end.month || new Date().getMonth() + 1; // Use current month if still working

    if (!startYear) return "Start date unknown";

    // Get company name
    const companyName = firstPosition.company?.name || "Unknown Company";

    // Calculate difference in years and months
    let years = endYear - startYear;
    let months = endMonth - startMonth;

    // Adjust if months are negative
    if (months < 0) {
      years -= 1;
      months += 12;
    }

    // Format output
    if (years === 0) return `${months} months at ${companyName}`;
    if (months === 0) return `${years} years at ${companyName}`;
    return `${years} years, ${months} months at ${companyName}`;
  };

  const fetchEmailFromProfile = async (profileCode) => {
    if (!profileCode) {
      handleError("notFound");
      return;
    }

    setState((prev) => ({ ...prev, loading: true, errorType: "", email: null }));

    try {
      const response = await fetch("https://api.leadbud.io/demo-tools/linkedintoEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ profile_code: profileCode }),
      });

      const responsev1 = await response.json();

      if (!response.ok || !responsev1.profile_details) {
        throw new Error(responsev1.message || "Email not found.");
      }

      const data = responsev1.profile_details;

      const namev1 = `${data.profile.first_name} ${data.profile.last_name}`;
      const tenure = calculateTenure(data.profile.position_groups);

      setState((prev) => ({
        ...prev,
        email: data.email,
        profileData: {
          name: namev1 || "Unknown Name",
          location: data.profile?.location?.short || "Unknown Location",
          title: data.profile?.sub_title || "No Title",
          company: {
            name: data.preview?.company?.name || "Unknown Company",
            industry: data.preview?.company?.industry || "N/A",
            location: data.preview?.company?.location || "Unknown",
            logo: data.preview?.company?.logo_url || "https://i.pinimg.com/736x/ec/d9/c2/ecd9c2e8ed0dbbc96ac472a965e4afda.jpg",
            tenure: tenure || "N/A",
          },
          riskScore: data.risk_score || 50,
          profileImage: data.profile?.profile_picture || "https://w7.pngwing.com/pngs/893/926/png-transparent-silhouette-user-icon-profile-silhouette-silhouette-avatar-profile-silhouette.png",
        },
        loading: false,
      }));
    } catch (err) {
      handleError("temporaryFailure");
    }
  };




  const [activeTab, setActiveTab] = useState('emailFinder'); // Default to Email Finder
  const riskScore = 90; // Example risk factor (0-100)
  const [darkMode] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [errorType, seterrorType] = useState('');

  const containerStyle = {
    padding: "38px 44px",
  };
  const alertStyle = {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "12px 16px",
    borderRadius: "10px",
    marginBottom: "10px",
  };
  const textStyle = {
    flex: 1,
    fontSize: "14px",
    color: "#333",
  };
  const buttonStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    padding: "8px 12px",
    border: "1px solid #EFEFEF",
    borderRadius: "10px",
    background: "linear-gradient(to top, #FBFBFB, white)",
    cursor: "pointer",
    boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.04)",
  };
  const errors = {
    limitReached: {
      message:
        "You've reached your daily request limit. Sign up for Leadbud and get up to 100 emails for free.",
      backgroundColor: "#FFEBE5",
      textColor: "#D32F2F",
      buttonText: "Let's go",
      link: "https://app.leadbud.io",
    },
    notFound: {
      message: "We couldn't find the email you are looking for. Want to try with another contact?",
      backgroundColor: "#FFF4E5",
      textColor: "#F57C00",
      buttonText: "Try again",
    },
    invalidDomain: {
      message: "The domain provided is invalid. Please check and enter a valid company domain.",
      backgroundColor: "#E3F2FD",
      textColor: "#1976D2",
      buttonText: "Retry",
    },
    temporaryFailure: {
      message: "We encountered a temporary issue fetching this email. Please try again later.",
      backgroundColor: "#E8F5E9",
      textColor: "#388E3C",
      buttonText: "Retry",
    },
    invalidLinkedInUrl: {
      message: "The LinkedIn URL provided is invalid. Please check and enter a valid LinkedIn profile URL.",
      backgroundColor: "#FBE9E7",
      textColor: "#D84315",
      buttonText: "Retry",
    },
  };
  // Function to get warning message based on risk score
  const getRiskMessage = () => {
    if (riskScore < 41) return "⚠️ High Risk: Be cautious!";
    if (riskScore < 71) return "⚠️ Medium Risk: Review carefully.";
    return "✅ Low Risk: Safe to proceed.";
  };






  return (
    <div
      style={{
        padding: '32px', // Equal padding on all sides
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '32px',
        width: '100%',
        maxWidth: '846px',
        margin: '0 auto',
        boxSizing: 'border-box', // Ensure padding doesn't overflow
      }}
    >

      <div style={{ display: 'flex', alignItems: 'flex-start', borderRadius: '6px', padding: '2px', border: '1px solid #E5E7EB', background: '#F5F6FA', width: '100%', maxWidth: '540px' }}>
        <button
          style={{
            flex: 1,
            height: '40px',
            padding: '0 12px',
            fontSize: '14px',
            background: activeTab === 'emailFinder' ? 'linear-gradient(to bottom, white, #F7F7F7)' : 'none',
            color: activeTab === 'emailFinder' ? '#374151' : '#6B7280',
            border: activeTab === 'emailFinder' ? '1px solid white' : '1px solid transparent',
            borderRadius: '4px',
            transition: 'all 0.2s ease-in-out',
          }}
          onClick={() => setActiveTab('emailFinder')}
        >
          Find from name
        </button>
        <button
          style={{
            flex: 1,
            height: '40px',
            padding: '0 12px',
            fontSize: '14px',
            color: activeTab === 'linkedin' ? '#374151' : '#6B7280',
            border: activeTab === 'linkedin' ? '1px solid white' : '1px solid transparent',
            borderRadius: '4px',
            background: activeTab === 'linkedin' ? 'linear-gradient(to bottom, white, #F7F7F7)' : 'none',
            transition: 'all 0.2s ease-in-out',
          }}
          onClick={() => setActiveTab('linkedin')}
        >
          Find from LinkedIn
        </button>
      </div>

      <div style={{ width: '100%', maxWidth: '1040px', backgroundColor: '#F5F6FA', borderRadius: '10px', paddingTop: '8px', paddingLeft: '8px', paddingRight: '8px', paddingBottom: '8px' }}>

        <div id="EmailFinder" style={{
          display: activeTab === 'emailFinder' ? 'flex' : 'none',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: '1040px'
        }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: '16px', justifyContent: 'space-between', alignItems: 'center', width: '100%', backgroundColor: '#FFFFFF', padding: '16px', border: '1px solid #F5F6FA', boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)', borderRadius: '10px' }}>
            <div style={{ display: 'flex', gap: '16px', flex: 1 }}>
              <div style={{ flex: 1 }}>
                <div style={{ position: 'relative', marginBottom: '6px', width: '100%' }}>
                  <label style={{ fontSize: '14px', fontWeight: '500', color: '#000000' }} htmlFor="input-first-name">First Name</label>
                  <input
                    style={{ height: '40px', padding: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', fontSize: '14px', borderRadius: '10px', border: '1px solid #E2E8F0', backgroundColor: '#FFFFFF', color: '#000000', fontWeight: '500' }}
                    id="input-first-name"
                    placeholder="John"
                    value=""
                  />
                </div>
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ position: 'relative', marginBottom: '6px', width: '100%' }}>
                  <label style={{ fontSize: '14px', fontWeight: '500', color: '#000000' }} htmlFor="input-last-name">Last Name</label>
                  <input
                    style={{ height: '40px', padding: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', fontSize: '14px', borderRadius: '10px', border: '1px solid #E2E8F0', backgroundColor: '#FFFFFF', color: '#000000', fontWeight: '500' }}
                    id="input-last-name"
                    placeholder="Doe"
                    value=""
                  />
                </div>
              </div>
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ position: 'relative', marginBottom: '6px', width: '100%' }}>
                <label style={{ fontSize: '14px', fontWeight: '500', color: '#000000' }} htmlFor="input-company-website">Company Website</label>
                <input
                  style={{ height: '40px', padding: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%', fontSize: '14px', borderRadius: '10px', border: '1px solid #E2E8F0', backgroundColor: '#FFFFFF', color: '#000000', fontWeight: '500' }}
                  id="input-company-website"
                  placeholder="example.com"
                  value=""
                />
              </div>
            </div>
            <button
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                whiteSpace: 'nowrap',
                borderRadius: '10px',
                transition: 'background-color 0.2s',
                outline: 'none',
                border: '1px solid #316BFF',
                background: 'linear-gradient(to top, #316BFF, #477BFF, #477BFF)',
                boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
                height: '40px',
                padding: '8px 12px',
                color: '#FFFFFF',
                fontSize: '14px',
                fontWeight: '500',
                width: '100%',
                maxWidth: 'fit-content',
                marginLeft: 'auto',
                marginRight: 'auto',
                alignSelf: 'center', // Add this line
              }}
            >
              <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="magnifying-glass" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: '16px', height: '16px', pointerEvents: 'none', marginRight: '8px' }}>
                <path fill="currentColor" d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"></path>
              </svg>
              Find email
            </button>
          </div>
          <button style={{ textAlign: 'center', fontSize: '14px', color: '#6B7280', padding: '16px 0', fontWeight: '400', transition: 'color 0.2s' }}>
            Not inspired? <span style={{ textDecoration: 'underline', color: 'inherit' }}>Try with Joy from Leadbud</span>
          </button>
        </div>

        <div id="Linkedin" style={{
          display: activeTab === 'linkedin' ? 'flex' : 'none',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: '1040px'
        }}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              gap: '16px',
              justifyContent: 'center',
              alignItems: 'flex-end',
              width: '100%',
              backgroundColor: '#FFFFFF',
              padding: '16px',
              border: '1px solid #F5F6FA',
              boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
              borderRadius: '10px',
            }}
          >
            <div style={{ flex: 1, position: 'relative' }}>
              <div style={{ position: 'relative', marginBottom: '6px', width: '100%' }}>
                <label
                  style={{
                    fontSize: '14px',
                    fontWeight: '500',
                    color: '#000000',
                  }}
                  htmlFor="input-linkedin-url"
                >
                  LinkedIn URL
                </label>
                <input
                  style={{
                    height: '40px',
                    padding: '8px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    fontSize: '14px',
                    borderRadius: '10px',
                    border: '1px solid #E2E8F0',
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    fontWeight: '500',
                  }}
                  placeholder="https://www.linkedin.com/in/username"
                  value={state.linkedinUrl}
                  onChange={(e) => setState((prev) => ({ ...prev, linkedinUrl: e.target.value }))}
                />
              </div>
            </div>
            <button
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                whiteSpace: 'nowrap',
                borderRadius: '10px',
                transition: 'background-color 0.2s',
                outline: 'none',
                border: '1px solid #316BFF',
                background: 'linear-gradient(to top, #316BFF, #477BFF, #477BFF)',
                boxShadow: '0px 0px 6px 0px rgba(0, 0, 0, 0.1), 0px 2px 4px 0px rgba(0, 0, 0, 0.1)',
                height: '40px',
                padding: '8px 12px',
                color: '#FFFFFF',
                fontSize: '14px',
                fontWeight: '500',
                width: '100%',
                maxWidth: 'fit-content',
              }}

              onClick={fetchProfileCode}
              disabled={state.loading}

            >
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="far"
                data-icon="magnifying-glass"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                style={{ width: '16px', height: '16px', pointerEvents: 'none', marginRight: '8px' }}
              >
                <path
                  fill="currentColor"
                  d="M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1L505 471c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L337.1 371.1z"
                ></path>
              </svg>
              Find email
            </button>
          </div>
          <button
            style={{
              textAlign: 'center',
              fontSize: '14px',
              color: '#6B7280',
              padding: '16px 0',
              fontWeight: '400',
              transition: 'color 0.2s',
            }}
          >
            Not inspired?{' '}
            <span style={{ textDecoration: 'underline' }}>Try with Joy from Leadbud</span>
          </button>
        </div>




        {state.loading && <div style={{ width: '100%', maxWidth: '1040px' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '16px', alignItems: 'center' }}>
            <div style={{ width: '100%' }}>
              <div style={{ backgroundColor: '#FFFFFF', borderRadius: '10px', border: '1px solid #F5F6FA', padding: '30px', maxHeight: '200px', overflowY: 'auto' }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>

                    <div style={{ color: '#6B7280', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                      <div style={{ width: '40px', height: '40px', borderRadius: '10px', backgroundColor: '#FFFFFF', boxShadow: '0px 0px 6px 0px rgba(16, 24, 40, 0.02), 0px 2px 4px 0px rgba(16, 24, 40, 0.08)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          data-prefix="fas"
                          data-icon="spinner"
                          role="img"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 512 512"
                          style={{
                            width: '16px',
                            height: '16px',
                            color: '#6B7280',
                            animation: 'spin 1s linear infinite',
                          }}
                        >
                          <style>
                            {`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
                `}
                          </style>
                          <path
                            fill="currentColor"
                            d="M304 48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm0 416a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM48 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm464-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM142.9 437A48 48 0 1 0 75 369.1 48 48 0 1 0 142.9 437zm0-294.2A48 48 0 1 0 75 75a48 48 0 1 0 67.9 67.9zM369.1 437A48 48 0 1 0 437 369.1 48 48 0 1 0 369.1 437z"
                          />
                        </svg>

                      </div>
                      {/* Left Section (Text) */}
                      <div style={{ fontWeight: '500' }}>
                        <div>Checking..</div>
                        <div style={{ fontSize: '14px' }}>0 out of 7 providers checked</div>
                      </div>

                      {/* Right Section (Lottie Animation) */}
                      <div id="lottie" style={{ background: 'transparent', outline: 'none', overflow: 'hidden', width: '100px', height: '100px' }}>
                        <SVGComponent />
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
        }
        {errorType && errors[errorType] && (
          <div
            style={{
              color: "#6B7280",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div style={containerStyle}>
              <div style={{ ...alertStyle, backgroundColor: errors[errorType].backgroundColor }}>
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="triangle-exclamation"
                  className="svg-inline--fa fa-triangle-exclamation"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 512 512"
                  style={{ color: errors[errorType].textColor, width: "20px", height: "20px" }}
                >
                  <path
                    fill="currentColor"
                    d="M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"
                  ></path>
                </svg>
                <span style={textStyle}>{errors[errorType].message}</span>

                {/* If error has a link, show button as a link */}
                {errors[errorType].link ? (
                  <a href={errors[errorType].link} target="_blank" rel="noopener noreferrer">
                    <button style={buttonStyle}>{errors[errorType].buttonText}</button>
                  </a>
                ) : (
                  <button style={buttonStyle} onClick={() => seterrorType("")}>
                    {errors[errorType].buttonText}
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        {/* Result Div For Linkedin Result  */}
        {state.profileData && (
          <div
            style={{
              width: "100%",
              background: darkMode ? "#1d1f23" : "#fff",
              color: darkMode ? "#eee" : "#333",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
              padding: "20px",
              fontFamily: "Arial, sans-serif",
              transition: "background 0.3s, color 0.3s",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "20px",
            }}
          >
            {/* Left Side: Profile Info */}
            {state.profileData && (
              <div style={{ flex: 1, display: "flex", alignItems: "center", textAlign: "left", gap: "15px" }}>
                <img
                  src={state.profileData.profileImage}
                  alt="Profile"
                  style={{ width: "70px", height: "70px", borderRadius: "50%" }}
                />
                <div>
                  <h3 style={{ margin: "0", fontSize: "12px" }}>{state.profileData.name}</h3>
                  <p style={{ fontSize: "10px", color: darkMode ? "#bbb" : "#777" }}>{state.profileData.location}</p>
                  <p style={{ fontSize: "9px" }}>{state.profileData.title}</p>
                </div>
              </div>
            )}

            {/* Right Side: Company Info */}
            {state.profileData && (
              <div
                style={{
                  flex: 2,
                  padding: "15px",
                  borderRadius: "8px",
                  background: darkMode ? "#2b2d30" : "#f5f6fa",
                  position: "relative",
                }}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <img
                    src={state.profileData.company.logo}
                    alt="Company Logo"
                    style={{ width: "50px", height: "50px", borderRadius: "5px" }}
                  />
                  <div>
                    <h4 style={{ margin: "0 0 5px", fontSize: "16px" }}>{state.profileData.company.name}</h4>
                    <p style={{ margin: "0 0 5px", fontSize: "14px" }}>
                      Industry: {state.profileData.company.industry}
                    </p>
                    <p style={{ margin: "0", fontSize: "14px" }}>{state.profileData.company.location}</p>
                  </div>
                </div>

                {/* Tenure Tooltip */}
                {hovered && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "-35px",
                      left: "50%",
                      transform: "translateX(-50%)",
                      background: darkMode ? "#333" : "#fff",
                      color: darkMode ? "#fff" : "#000",
                      padding: "6px 10px",
                      borderRadius: "6px",
                      fontSize: "12px",
                      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {state.profileData.company.tenure}
                  </div>
                )}

                {/* Contact Info */}
                <div style={{ marginTop: "15px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                  {/* Email Section */}
                  <p style={{ fontSize: "14px" }}>
                    Email: {" "}
                    <span
                      style={{
                        background: "#eee",
                        padding: "5px 8px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "inline-flex",
                        alignItems: "center",
                      }}
                      onClick={() => handleCopy(state.profileData.email)}
                    >
                      {state.profileData.email || "Not Available"} <Copy size={14} style={{ marginLeft: "5px" }} />
                    </span>
                  </p>

                  {/* Risk Score Section */}
                  <div style={{ display: "flex", alignItems: "center", position: "relative" }}>
                    <p style={{ fontSize: "14px", marginRight: "10px" }}>Risk Score:</p>
                    <div
                      style={{
                        width: "100px",
                        height: "8px",
                        background: "#ddd",
                        borderRadius: "5px",
                        position: "relative",
                      }}
                      onMouseEnter={() => setShowTooltip(true)}
                      onMouseLeave={() => setShowTooltip(false)}
                    >
                      <div
                        style={{
                          width: `${state.profileData.riskScore}%`,
                          height: "100%",
                          borderRadius: "5px",
                          marginBottom: "17px",
                          background:
                            state.profileData.riskScore < 41
                              ? "red"
                              : state.profileData.riskScore < 71
                                ? "orange"
                                : "green",
                        }}
                      ></div>
                      {showTooltip && (
                        <div
                          style={{
                            position: "absolute",
                            bottom: "150%",
                            left: "50%",
                            transform: "translateX(-50%)",
                            padding: "6px 10px",
                            background: "#333",
                            color: "#fff",
                            borderRadius: "4px",
                            fontSize: "12px",
                            whiteSpace: "nowrap",
                            zIndex: 10,
                          }}
                        >
                          {getRiskMessage()}
                        </div>
                      )}
                    </div>
                    <span style={{ fontSize: "14px", marginLeft: "10px", marginBottom: "16px" }}>{state.profileData.riskScore}%</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
        {/* Footer From Shown All Finder */}
        {state.profileData && (
          <div
            style={{
              borderRadius: "10px",
              border: "none",
              boxShadow: "none",
              paddingTop: "24px",
              paddingBottom: "24px",
              paddingLeft: "40px",
              paddingRight: "40px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                color: "black",
                fontSize: "16px",
                fontWeight: "normal",
                padding: "0",
              }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <p style={{ fontWeight: "500" }}>We found other employees in that company</p>
                <p style={{ color: "#888" }}>Find their emails and phone number for free with leadbud</p>
              </div>
              <a target="_blank" rel="noopener noreferrer" href="https://app.leadbud.io">
                <button
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    transition: "0.2s ease-in-out",
                    outline: "none",
                    border: "1px solid #EFEFEF",
                    color: "#333",
                    background: "linear-gradient(to top, #FBFBFB, white)",
                    borderRadius: "10px",
                    boxShadow: "0px 1px 3px rgba(0,0,0,0.04)",
                    height: "40px",
                    paddingLeft: "12px",
                    paddingRight: "12px",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    fontSize: "14px",
                    fontWeight: "500",
                    textAlign: "center",
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                  }}
                >
                  See all profiles
                </button>
              </a>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}


